(ns practitest.frontend.common.uri
  (:require [goog.Uri :as uri]))

(defn parse-query-params
  [url]
  (try
    (let [parsed (uri/parse url)
          m (transient {})]
      (.forEach (.getQueryData ^goog.Uri parsed)
                (fn [v k]
                  ;; TODO: query params can have multiple entries with the same key
                  (assoc! m k v)))
      (persistent! m))
    (catch js/Error e
      (js/console.warn e "Error parsing query params" url))))

(defn has-query-param?
  ([url key] (has-query-param? url key :any))
  ([url key value]
   (try
     (let [parsed (uri/parse url)
           param-value (.getParameterValue parsed key)]
       (or (and param-value (= :any value))
           (= value param-value)))
     (catch js/Error e
       (js/console.warn e "Error parsing query params" url)
       false))))

(defn set-query-param [url name value]
  (try
    (let [parsed (uri/parse url)]
      (.setParameterValue parsed name value)
      (.toString parsed))
    (catch js/Error e
      (js/console.warn e "Error parsing query params" url)
      ;; TODO: should we try and append the parameter manually? Feels wrong
      url)))

(defn remove-query-param [url name]
  (try
    (let [parsed (uri/parse url)]
      (.removeParameter parsed name)
      (.toString parsed))
    (catch js/Error e
      (js/console.warn e "Error parsing query params" url)
      url)))

(comment

  (parse-query-params "/projects/4980/pattachments/200328?entity_id=80581&entity_type=suite?style=thumb")

  ;; happy path
  (set-query-param  "/projects/4980/pattachments/200328?entity_id=80581&entity_type=suite" "style" "thumb")
  (set-query-param "/projects/4980/pattachments/200328?entity_id=80581&entity_type=suite&style=thumb" "style" "orig")
  (set-query-param "projects/4980/pattachments/200328" "style" "thumb")
  (remove-query-param  "/projects/4980/pattachments/200328?entity_id=80581&entity_type=suite&style=thumb" "style")
  (remove-query-param  "/projects/4980/pattachments/200328?style=thumb" "style")
  (has-query-param? "/projects/4980/pattachments/200328?entity_id=80581&entity_type=suite&style=thumb" "style")
  (has-query-param? "/projects/4980/pattachments/200328?entity_id=80581&entity_type=suite&style=thumb" "style" "thumb")
  (has-query-param? "/projects/4980/pattachments/200328?entity_id=80581&entity_type=suite&style=thumb" "style" "original")
  (has-query-param? "/projects/4980/pattachments/200328?entity_id=80581&entity_type=suite&style=thumb" "something-else")
  ;; bad URL
  ;; well, i tried to make it fail, it doesnt, 
  (set-query-param [1 2 3] "style" "thumb")
  
  )
